import { cleanFalsyValues } from '@/utils/objects'

export const buildQueryString = (params: Record<string, any>): string => {
  const queryParams = new URLSearchParams(cleanFalsyValues(params))

  return queryParams.toString()
}
